import React from "react";
const config = require("../config");
const helper = require("../helper");
const Modal = require("../comp_misc").modal;
const helperFile = require("./admin_helper.js");
const Pager = require("../comp_misc").pager;

// https://reactjs.org/docs/lists-and-keys.html react lists


var g_link = "/admin/manuals";

function ListItem(props) {
  // Correct! There is no need to specify the key here:
  return <tr>
    <td>{props.item.airlineName}</td>
<td>{props.item.courseName}</td>
<td>{props.item.title}</td>
<td>{props.item.filename}</td>
<td>{props.item.version}</td>
<td>undefined</td>

  <td align="center"><button type="button" class="btn btn-outline-primary" onClick={() =>
    {
    props.parent.showModal(props.item) }
  }><i class="fa fa-edit mr-2" aria-hidden="true"></i>Edit</button></td>  

</tr>

}

class ModalList1 extends React.Component {
  

  constructor(props)
  {
    super(props);
    var params = helper.parseQuery();
    var page = params.p;
    if (!page)
      page = 0;

    this.state = {
      rows: null,
      error:null,
      image: null,
      page: page,
      
    };
  }


checkInits()
{

}

fillList(filter)
{
  var rows1 = [];

  helper.getFromServer(g_link+"?dw=get&filter="+filter)
  .then(res => {

    this.setState({showForm: false, rows: res.result, options: res.options, count: res.options.count});
  })



}
 componentDidMount() {
  this.fillList()  
  }

  showModal(item)
  {
      
//    this.setState({showForm: true, image: "/api/media/logo"+item.id+".png", id: item.id, name: item.name, email: helper.checkNull(item.email), error: ""});
    this.setState({showForm: true, id: item.id, courseId: item.courseId, airlineId: item.airlineId, title: item.title, version: item.version, image: "/api/media/manual"+item.id+".svg",alert: '', error: ""});
}

  hideModal()
  {
    this.setState({show: false});
  }

  saveItem()
  {
//    helper.postToServer(g_link, {dw: "update", id: this.state.id, email: this.state.email, name: this.state.name}, true)
    helper.postToServer(g_link, {dw: "update", id: this.state.id, courseId: this.state.courseId, airlineId: this.state.airlineId, title: this.state.title, version: this.state.version, }, true)
.then(res => {
      this.fillList();
    })
    .catch(err => {
      this.setState({error: err});
    })

  }
  addItem()
  {
    var item = {id: -1};
    this.showModal(item);
/*
    helper.postToServer(g_link, {dw: "add"}, true)
    .then(res => {
      this.fillList()
    })
    .catch(err => {
      alert("AU Said : "+err)
    })
*/
  }

  deleteItem()
  {

    helper.postToServer(g_link, {dw: "del", id: this.state.id}, true)
    .then(res => {
      this.fillList()
    })
    .catch(err => {
      alert("AU Said : "+err)
    })

  }
  
  hiCheck1(event)
  {
    const target = event.target;
    const name = target.name;
    let value;
    if (target.checked)
      value = target.checked;
    else
      value = 0;

      this.setState({
        [name]: value
      });
  }

  
  filter(event)
  {
    const target = event.target;
//    const name = target.name;
    var value = target.value;

    this.fillList(value);

  }

  hic(event) {

    const target = event.target;
    const name = target.name;

    let value;
//    const value = target.type === 'checkbox' ? target.checked : target.value;
    if (target.type === 'checkbox')
    {
      value = this.state[name];
      if (!value)
        value = [];
        // assumes DOM won't feed us dupes
        var vint = parseInt(target.value);

      if (target.checked)
      {
        value.push(vint);
      }
      else
      {
        var index = value.indexOf(vint);
        if (index !== -1) value.splice(index, 1);
      }
    }
    else
    {
      value = target.value;
    }
    this.setState({
      [name]: value
    });
  
  }

  onFile() {

  // OE??!! Fix this because it it confusing and only allows 1 _t per page
    var file = document.getElementById("manualUpload").files[0];
  
    var formData = new FormData();
    formData.append('file', file);
    formData.append('id', this.state.id)
    formData.append("dw", "saveFile")
    
    fetch(config.back+g_link+"_up", {
      method: 'POST', credentials: "same-origin",
      body: formData
    }).then(response => response.json())
    .then(res => {
      
      this.setState({image: "/api/media/manual"+this.state.id+".svg?"+new Date().getMilliseconds(),
    alert: "File was uploaded"});
    })
    .catch(error => { 
      alert(error);
    });
   //.then(response => console.log('Success:', response));
    
  }
    

  render() {
document.title = "Manuals";

let spinner;
let pager;
if (!this.state.rows)
{
  spinner = <div class="d-flex justify-content-center">
  <div class="spinner-border spinner text-primary" role="status">
      <span class="sr-only">Loading...</span>
  </div>
</div>;
}
else
{
  pager = <Pager page={this.state.page} count={this.state.options.count} link={g_link}/>;
}

var error1 = <div class="alert alert-danger" role="alert">
<i class="fa fa-times mr-2" aria-hidden="true"></i>{this.state.error}
</div>;
if (!this.state.error)
error1 = <div></div>;
var alert1 = <div class="alert alert-success" role="alert">
<i class="fa fa-check mr-2" aria-hidden="true"></i>{this.state.alert}
</div>;

if (!this.state.alert)
    alert1 = <div></div>

let listItems;
var filterItems = [];

if (this.state.rows)
{


  listItems = this.state.rows.map((item, index) =>

    <ListItem key={index} item={item} parent={this} />
  );

  if (this.state.options.filters)
  {
    this.state.options.filters.map((item) => {
      filterItems.push(<option value={item.id}>{item.name}</option>)
    });
  }

}
if (this.state.showForm)
{
  this.checkInits();
  var courseList = this.state.options.courseList.map((item, index) =>
                <option value={item.id}>{item.name}</option>);
var airlineList = this.state.options.airlineList.map((item, index) =>
                <option value={item.id}>{item.name}</option>);

  
  

  let deleteButton;

  if (this.state.id != -1)
  {
    deleteButton = <button type="submit" class="btn btn-danger mt-4" onClick={this.deleteItem.bind(this)}>Delete</button>
  }

  return(
<div>{helperFile.nav()}

    <div class="container my-4">
        <h2 class="text-primary mb-4"><i class="fa fa-book mr-2" aria-hidden="true"></i>Manual Form</h2>
        {error1}
        {alert1}
{/*<!-- user info block start -->*/}
        <div class="data-container">
            <div class="row mb-2">
                <div class="col-12">
                    <h4>Add/Edit Manual</h4>
                </div>
            </div>
            <hr class="border-primary mb-4"/>
            
{/*<!-- form start -->*/}
        <div class="row">
            <div class="col-xl-8 col-lg-8 col-md-12 col-sm-12 col-12">
                <p>Manual content are associated with courses for user display in PDF format within a pdf viewer container. However the PDF manual must be asscociated with a specified airline due to authority requirements of airline logo display on the manual and possibily specific content for the airline.</p>
                
                    <div class="form-group">

                        <select id="selec1tManual"  class="form-control"  name="courseId" value={this.state.courseId}  onChange={this.hic.bind(this)}>
                            <option selected>Select course to assign this content to...</option>
                            {courseList}
                        </select>

                    </div>
                    
                    <hr class="border-primary my-4"/>
                    
                    <h5 class="text-primary mb-3">Manual Upload:</h5>
                    <div class="form-group">

                        <select id="selectAirline" class="form-control"  name="airlineId" value={this.state.airlineId}  onChange={this.hic.bind(this)}>
                            <option selected>Select airline to use this manual</option>
                            {airlineList}
                        </select>

                    </div>
                    <div class="form-group">
                        <input type="text"  name="title" value={this.state.title} onChange={this.hic.bind(this)}  class="form-control" placeholder="Manual Title"/>
                        <small id="manualTitleHelp" class="form-text text-muted">Enter the manual title as it should appear for the user, example: RVSM Text Based Manual</small>
                    </div>
                    <div class="form-group">
                        <input type="text"  name="version" value={this.state.version} onChange={this.hic.bind(this)}  class="form-control w-50" id="manualVersion" placeholder="Version.. i.e V2"/>
                        <small id="manualVersionHelp" class="form-text text-muted">Enter the manual version to keep track of updates, example v2, v3..</small>
                    </div>
                    
                    <h6>Upload Manual:</h6>
                    <ul class="mb-5">
                        <li>The manual must be in PDF format to show correctly in the PDF viewer, ensure manual must bear the airline logo.</li>
                        <li>To replace already uploaded manual, choose and upload the new manual and save this form.</li>
                        <li>If manual is deleted and no file exists for this manual, it will not show for the user.</li>
                    </ul>
                        <div class="form-group">
                            <input type="file" class="form-control-file" id="manualUpload"  name="manual" value={this.state.manual} onChange={this.onFile.bind(this)}  />
                            <a href={"/api/media/manual"+this.state.id+".pdf"}>Manual</a>
                    </div>
                    

                    <button type="submit" class="btn btn-primary mt-4" onClick={this.saveItem.bind(this)}>Add/Update Manual</button>&nbsp;{deleteButton}&nbsp;<button class="btn btn-danger mt-4" onClick={() => {this.setState({showForm:false})}}>Close</button>
              
            </div>
        </div>
     </div>
 </div>
      

</div>


  )
  }
  else
  {
return(
<div>
  {spinner}
{helperFile.nav()}

    <div class="container my-4">
        <h2 class="text-primary mb-4"><i class="fa fa-database mr-2" aria-hidden="true"></i>Manuals</h2>

        <div class="data-container">
            <div class="row mb-2">
                <div class="col-8">
                    <p>Manual list contains all manuals for all courses for all airlines, the list is sorted in Alphabetical order by the airline name.</p>
                </div>
                <div class="col-4">
                    <div class="card bg-secondary">
                        <div class="card-body text-center font-weight-bolder text-white">
                        Mauals: {this.state.count}
                        </div>
                    </div>
                </div>
            </div>
            <hr/>
            

            <div class="container d-flex my-4 px-0 justify-content-between">
                <a class="btn btn-primary" role="button" onClick={this.addItem.bind(this)}><i class="fa fa-database mr-2" aria-hidden="true"></i>Add Manual</a>
                <input class="form-control w-40" id="myInput" type="text" placeholder="Search.. by anything"/>
            </div>
            <div class="container d-flex my-4 px-0 justify-content-center"><div class="dropdown">
    <select id="inputState" class="form-control" onChange={this.filter.bind(this)}>
    <option selected>Choose Airline...</option>
    {filterItems}
    </select></div></div>


            <div class="row">
                <div class="col-xl-12 col-lg-12 col-md-12 col-12">
                    <table class="table mb-0 table-hover">
                      <thead>
                        <tr>
                          <th scope="col" >Airline</th>  
                          <th scope="col" >Course</th>
                          <th scope="col" >Title</th>
                          <th scope="col" >File</th>
                          <th scope="col" >Version</th>
                          <th scope="col" class="text-center" width="120">Action</th>
                        </tr>
                      </thead>
                      <tbody id="myTable">
                      {listItems}
                      </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
      

    {pager}
 {helperFile.footer()}
 
</div>

)
  }}
}


export default ModalList1
